import styled, { css } from "styled-components"
import { Link as GLink } from "gatsby"

import { media } from "src/uikit"

export const Container = styled.div`
  width: 100%;
  max-width: 357px;
  min-height: 100%;
  border-radius: 16px;
  padding: 32px;
  padding-bottom: 0;
  position: relative;

  background: linear-gradient(255.03deg, #7785ff -0.91%, #6472ef 102.89%);

  display: flex;
  flex-direction: column;

  margin-left: 32px;
  margin-right: 32px;

  cursor: pointer;
  transition: 0.3s;

  ::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: linear-gradient(255.03deg, #8692ff -0.91%, #7481f4 102.89%);
    opacity: 0;
    transition: 0.3s;
    border-radius: 16px;
    z-index: 1;
  }

  :hover {
    ::after {
      opacity: 1;
    }
  }

  @media (max-width: 1260px) {
    margin-bottom: 40px;
    margin-left: 0;
    margin-right: 0;
  }

  @media ${media.mobile} {
    width: 288px;
    padding: 24px 16px 16px 16px;
  }
`

export const Title = styled.p`
  font-weight: bold;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0.4px;
  color: #ffffff;
  margin: 0;
  z-index: 2;
`

export const Description = styled.p`
  margin: 0;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 15px;
  line-height: 28px;
  letter-spacing: 0.4px;
  color: #fff;
  z-index: 2;
`

export const Button = styled.span`
  margin-top: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  font-weight: bold;
  font-size: 13px;
  line-height: 15px;
  text-align: center;
  letter-spacing: 0.4px;
  color: #ffffff;
  cursor: pointer;
  padding: 0;
  width: 100%;
  height: 40px;
  text-transform: uppercase;
  text-decoration: none;
  z-index: 2;
`

const linkStyle = css`
  text-decoration: none;
  outline: none;
  color: #fff;
`

export const Link = styled.a`
  ${linkStyle}
`

export const InnerLink = styled(GLink)`
  ${linkStyle}
`
